import React, { Component } from 'react';
import { Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { withTranslation } from 'react-i18next';

import styles from './Header.scss';
import CodeEditorTitle from './CodeEditorTitle';
import ThemeSwitcher from './ThemeSwitcher';
import LanguageSelector from './LanguageSelector';
import EditorExpandButton from './EditorExpandButton';

// allows the user to change language
class Header extends Component {
  handleDriverCodeModalToggle = () => {
    if (this.props.onDriverCodeModalToggle) {
      this.props.onDriverCodeModalToggle(this.props.selectedLanguage, this.props.activeTemplate);
    }
  };

  render() {
    const { t, problemId } = this.props;
    const isDarkTheme = this.props.theme === 'vs-dark';

    return (
      <div
        className={styles.EditorHeader}
        style={{ backgroundColor: isDarkTheme ? '#1e1e1e' : '#fff' }}
      >
        <CodeEditorTitle theme={this.props.theme} />

        <div
          className={styles.headerRight}
          style={{ display: 'flex', alignItems: 'center', gap: '16px' }}
        >
          <ThemeSwitcher
            theme={this.props.theme}
            toggleTheme={this.props.toggleTheme}
          />

          <LanguageSelector
            selectedLanguage={this.props.selectedLanguage}
            languageList={this.props.languageList}
            switchLanguage={this.props.switchLanguage}
            problemId={problemId}
          />

          <Tooltip title={t('editor.driver_code_tooltip')}>
            <InfoCircleOutlined
              style={{ color: '#1890ff', cursor: 'pointer' }}
              onClick={this.handleDriverCodeModalToggle}
            />
          </Tooltip>

          <EditorExpandButton
            theme={this.props.theme}
            editorExpand={this.props.editorExpand}
            toggleExpand={this.props.toggleExpand}
          />
        </div>
      </div>
    );
  }
}

export default withTranslation('common')(Header);
